import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ColDef, ColGroupDef, GridOptions } from 'ag-grid-community';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { APP_VALIDATION_REGEX, UI_MESSAGES } from 'src/app/app.contant';
import { AgGridWrapperComponent } from 'src/app/modules/shared/components/ag-grid-wrapper/ag-grid-wrapper.component';
import { PrBuyerDashboardService } from '../../../services/pr-buyer-dashboard.service';
import { PrBuyerHelperService } from '../../../services/pr-buyer-helper.service';

@Component({
  selector: 'app-add-unRegisteredvendors',
  templateUrl: './add-unRegisteredvendors.component.html',
  styleUrls: ['./add-vendors.component.scss']
})
export class AddUnRegisteredVendorsComponent implements OnInit {
  public unregisteredVendorForm!: FormGroup;
  public onClose = new Subject<any>();


  constructor(
    public bsModalRef: BsModalRef,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.unregisteredVendorForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      contact_number: ['', Validators.required],
      country: ['', Validators.required],
      city: ['', Validators.required]
    });
  }

  submitVendor() {
    if (this.unregisteredVendorForm.valid) {
      const vendorData = this.unregisteredVendorForm.value;
      this.closeModal(vendorData);
    } else {
      // Optionally, display validation errors
    }
  }

  // onClose(success: boolean, data?: any): void {
  //   this.bsModalRef.content.onClose.next({
  //     success,
  //     data
  //   });
  //   this.bsModalRef.hide();
  // }

  public onModalClose(): void {
    this.bsModalRef.hide();
  }

  public closeModal(data ?: any) {
    this.onClose.next(data);
    this.bsModalRef.hide();
  }
}
